import publicV2Api from '../../../api/publicV2.js'

export default {
  list: (payload, callback) => {
    const pageId = payload.query.pageId;
    publicV2Api.get(`/tools?pageId=${pageId}`, (error, responseData) => {
      if (error) return callback(error, null);
      callback(null, responseData);
    });
  },
  executeManual: (payload, callback) => {
    const pageId = payload.query.pageId;
    const requestBody = payload.body || {};
      publicV2Api.post(`/tools/execute?pageId=${pageId}`, requestBody, (fallbackError, fallbackResponse) => {
        if (fallbackError) return callback(fallbackError, null);
        callback(null, fallbackResponse);
      });
  }
} 